<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Estimated Payslips</h1>
    <p>
      To allow us to plan onboarding and future payroll resource, for each pay frequency
      that will be processed please confirm the estimated number of payslips for
      {{ formData.clientName }}.
    </p>
  </div>

  <div class="cell small-12">
    <EditableTable
      v-model="formData.estimatedPayslips"
      :columns="columns"
      :buttonName="'Add Pay Frequency'"
      :noRowsMessage="'Please add a pay frequency'"
      autoSaveOnChange
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import EditableTable from '@/components/controls/EditableTable.vue'

const error = ref([])

const props = defineProps({
  formData: Object
})

const columns = [
  {
    field: 'payFrequency',
    label: 'Pay Frequency',
    type: 'combo',
    placeholder: 'Choose…',
    options: [
      { value: 'Weekly', label: 'Weekly' },
      { value: 'Two Weekly', label: 'Two Weekly' },
      { value: 'Four Weekly', label: 'Four Weekly' },
      { value: 'Monthly', label: 'Monthly' }
    ]
  },
  {
    field: 'numberOfPayslips',
    label: 'Number of Payslips',
    type: 'number',
    placeholder: 'Number of Payslips'
  }
]

const validateStep = () => {
  error.value = []

  const rows = Array.isArray(props.formData?.estimatedPayslips)
    ? props.formData.estimatedPayslips
    : []

  if (rows.length === 0) {
    error.value.push('Please add at least one pay frequency.')
    return false
  }

  rows.forEach((row, index) => {
    const rowNum = index + 1
    const payFrequency = String(row?.payFrequency ?? '').trim()
    const numberOfPayslips = Number(row?.numberOfPayslips)

    if (!payFrequency) {
      error.value.push(`Row ${rowNum}: Please select a pay frequency.`)
    }

    if (!Number.isFinite(numberOfPayslips) || numberOfPayslips <= 0) {
      error.value.push(
        `Row ${rowNum}: Number of payslips must be greater than 0.`
      )
    }
  })

  return error.value.length === 0
}

const executeStep = async () => {
  return true
}

defineExpose({ validateStep, executeStep })
</script>
